module.exports = __webpack_public_path__ + "static/media/aboutUs-sun.8cabcee0.svg";